export default {
  compareRoles(allowedRoles, userRoles) {
    let match = false;

    allowedRoles.forEach((allowedRole) => {
      userRoles.forEach((userRole) => {
        if (userRole === allowedRole) match = true;
      });
    });

    return match;
  },
  checkPermissions(allowedRoles, currentUser) {
    const userRoles = currentUser.roles.map((role) => (role.roleCode));
    const userRolesFamilies = currentUser.roles.map((role) => (role.role.familyCode));
    return this.compareRoles(allowedRoles, userRoles.concat(userRolesFamilies));
  },
};
